import React from 'react';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from 'src/shared/components/ui/sheet';
import InfoMessage from 'src/shared/components/info-message/InfoMessage';
import OrganisationLicences from 'src/app/admin/components/organisation-licences/OrganisationLicences';

type OrganisationProductsSheetProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    customerId: string;
    customerName: string;
};

const OrganisationProductsSheet = ({ open, onOpenChange, customerId, customerName }: OrganisationProductsSheetProps) => (
    <Sheet open={open} onOpenChange={onOpenChange}>
        {/* Scrolls, so the last rows stay in reach on a short screen. */}
        <SheetContent className='overflow-y-auto'>
            <SheetHeader>
                <SheetTitle>Licensed Products</SheetTitle>
                <SheetDescription>
                    Choose which products the {customerName} ({customerId}) organisation&#8217;s users can see. Changes save as you make
                    them.
                </SheetDescription>
            </SheetHeader>

            <div className='mt-6 flex flex-col gap-4'>
                <InfoMessage
                    className='!m-0'
                    message={
                        <span>
                            Internal users see an onboarded organisation&#8217;s results whether or not the product is released, so these
                            switches govern what the customer sees.
                        </span>
                    }
                />

                <OrganisationLicences customerId={customerId} />
            </div>
        </SheetContent>
    </Sheet>
);

export default OrganisationProductsSheet;
